import React from "react";
import { Link } from "react-router-dom";
import style from "./community.module.css";
import Communitydata from "./Community_Data/CommunityData";
const Community = () => {
  return (
    <div className="container">
      <div className={style.main_container}>
        <div className={style.top_bar_image_div}>
          <img
            src="https://modesens.com/banner/12428/getimg/?img=%2Fbanner%2F20220610-modesens-hashtag-1440x250-F.jpg"
            alt="TopImage"
          />
          <div className={style.top_bar_image_text}>
            <h1>Dreaming of Ice Cream</h1>
            <p>Fill up on #summercolors</p>
          </div>
        </div>
        <div className={style.community_bar_links}>
          <Link to="/community">Following </Link>
          <Link to="/community">Discover</Link>
        </div>
        <div>
          <Communitydata></Communitydata>
        </div>
      </div>
    </div>
  );
};

export default Community;
